// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2601":"8c5a47ce","6348":"b0cb0171","7500":"58a81b60"}[chunkId] + ".chunk.css";
};